import { ReadEmployee } from '@/services/gql/graphql.generated';
import { useCanEditEmployee } from '@/services/settings/useCanEditEmployee';
import { FC } from 'react';
import { FiClipboard } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { TSTitleCard } from '../../../../components/shared/card/Card';
import { strings } from '../../../../services/translation/strings';
import { useWorkRules } from '../../../../services/workRules/useWorkRules';

export const WorkRulesCard: FC<{ employee: ReadEmployee }> = ({ employee }) => {
  const ruleContainerClass = 'flex flex-col gap-2';
  const { rules } = useWorkRules(employee.identityId);

  const canEdit = useCanEditEmployee();

  const navigate = useNavigate();

  const onEditClick = () => {
    navigate(`/team-member/${employee.identityId}/edit-workRules`);
  };

  return (
    <TSTitleCard
      className="bg-white"
      title={strings.timeshift.teamMember.workRules.cardTitle}
      icon={FiClipboard}
      primaryAction={
        canEdit
          ? {
              label: strings.timeshift.teamMember.workRules.edit,
              onClick: onEditClick
            }
          : undefined
      }
    >
      <div className="grid grid-cols-2 gap-4">
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.workRules.minimumMonthlyHours}</span>
          <span>{rules.minMonthlyHours ? rules.minMonthlyHours : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.workRules.maximumMonthlyHours}</span>
          <span>{rules.maxMonthlyHours ? rules.maxMonthlyHours : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.workRules.minimumWeeklyHours}</span>
          <span>{rules.minWeeklyHours ? rules.minWeeklyHours : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.workRules.maximumWeeklyHours}</span>
          <span>{rules.maxWeeklyHours ? rules.maxWeeklyHours : '-'}</span>
        </div>
        {/* <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.workRules.probationEndDate}</span>
          <span>{employee.endOfProbationDate || '-'}</span>
        </div> */}
      </div>
    </TSTitleCard>
  );
};
